// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleDropIndicatorElement, type TableHandleDropIndicatorElement, type TableHandleDropIndicatorProps as TableHandleDropIndicatorElementProps } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes, useLayoutEffect } from 'react';

import { useEditorContext } from '../../contexts/editor-context.ts';

/** Props for the {@link TableHandleDropIndicator} React component. */
export interface TableHandleDropIndicatorProps {
  /**
   * @default null
   * @hidden
   */
  editor?: TableHandleDropIndicatorElementProps['editor'];
}

function TableHandleDropIndicatorComponent(props: TableHandleDropIndicatorProps, forwardedRef: ForwardedRef<TableHandleDropIndicatorElement>) {
  registerTableHandleDropIndicatorElement();

  const elementRef = useRef<TableHandleDropIndicatorElement>(null);

  const p0Fallback = useEditorContext();

  const { editor: p0, ...restProps } = props;

  useLayoutEffect(() => {
    const element = elementRef.current as Record<string, unknown> | null;
    if (!element) return;
    Object.assign(element, { editor: p0 ?? p0Fallback });
  });

  const mergedRef = useCallback(
    (element: TableHandleDropIndicatorElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-drop-indicator', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-drop-indicator` custom element. */
export const TableHandleDropIndicator: ForwardRefExoticComponent<TableHandleDropIndicatorProps & HTMLAttributes<TableHandleDropIndicatorElement> & RefAttributes<TableHandleDropIndicatorElement>> = /* @__PURE__ */ forwardRef(TableHandleDropIndicatorComponent);
